import { useLayoutEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Redirect, RouteChildrenProps, Switch, useRouteMatch } from 'react-router-dom';
import Content from 'assets/js/components/Content';
import { CreateWorkflow } from 'assets/js/pages/engage/workflows/CreateWorkflow';
import { EditWorkflowBuilder } from 'assets/js/pages/engage/workflows/EditWorkflowBuilder';
import { EditWorkflowReview } from 'assets/js/pages/engage/workflows/EditWorkflowReview';
import { WorkflowDetails } from 'assets/js/pages/engage/workflows/WorkflowDetails';
import { WorkflowsIndex } from 'assets/js/pages/engage/workflows/WorkflowsIndex';
import { useReactFlowStore } from 'assets/js/pages/engage/workflows/utils/store';
import { WorkflowsGivebutterPlusSplashPage } from 'components/givebutter-plus-splash/WorkflowsGivebutterPlusSplashPage';
import { Route } from 'components/router/Route';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const WorkflowsRouter = () => {
    const { hasGivebutterPlusAccess } = useCurrentAccount();
    const match = useRouteMatch();

    if (!hasGivebutterPlusAccess) {
        return <WorkflowsGivebutterPlusSplashPage />;
    }

    return (
        <Content>
            <Switch>
                <Route path={`${match.path}/:workflow_id(\\d+)`} component={WorkflowRouter} />
                <Route path={`${match.path}/new`} component={CreateWorkflow} />
                <Route path={match.path} component={WorkflowsIndex} />
            </Switch>
        </Content>
    );
};

const WorkflowRouter = ({ match }: RouteChildrenProps<{ workflow_id: string }>) => {
    const { accountId } = useCurrentAccount();
    const { reset } = useReactFlowStore(({ reset }) => ({ reset }));

    useLayoutEffect(() => {
        // reset the zustand store when workflow_id changes
        // - needs to be in a useLayoutEffect to run before the store is
        //   initialized with data on first render
        reset();
    }, [match?.params.workflow_id, reset]);

    return (
        <ErrorBoundary fallback={<Redirect to={`/accounts/${accountId}/workflows`} />}>
            <Switch>
                <Route path={`${match?.path}/build`} component={EditWorkflowBuilder} />
                <Route path={`${match?.path}/review`} component={EditWorkflowReview} />
                <Route path={match?.path} component={WorkflowDetails} />
            </Switch>
        </ErrorBoundary>
    );
};
export { WorkflowsRouter };
